module.exports = __webpack_public_path__ + "img/shipo-icon-see-green.6f6c7cf8.svg";